import localforage from 'localforage'

export default {
	getItem(key) {
		if (!window.isCordovaApp) {
			return localforage.getItem(key);
		} else {
			return new Promise((resolve, reject) => {
				NativeStorage.getItem(key, (result) => {
					resolve(result);
				},
				(error) => {
					if (error.code == 2) {
						resolve(undefined);
					}
					reject(error);
				})
			});
		}
	},
	setItem(key, value) {
		if (!window.isCordovaApp) {
			return localforage.setItem(key, value);
		} else {
			return new Promise((resolve, reject) => {
				NativeStorage.setItem(key, value, (result) => {
					resolve(result);
				},
				(error) => {
					if (error.code == 2) {
						resolve(undefined);
					}
					reject(error);
				})
			});
		}
	},
	removeItem(key) {
		if (!window.isCordovaApp) {
			return localforage.removeItem(key);
		} else {
			return new Promise((resolve, reject) => {
				NativeStorage.remove(key, (result) => {
					resolve(result);
				},
				(error) => {
					if (error.code == 2) {
						resolve(undefined);
					}
					reject(error);
				})
			});
		}
	},
}